import { useEffect, useState } from 'react';
import routes from '@root/routes';
import api from '@shared/api';
import { LandlordPortfolio } from '@root/types';

export default function useRegion(marketSlugs: string[], landlordSlug: string) {
  const [selectedRegionSlug, setSelectedRegionSlug] = useState<string | null>(marketSlugs[0]);
  const [selectedPortfolio, setSelectedPortfolio] = useState<LandlordPortfolio | null>(null);

  useEffect(() => {
    const fetchPortfolio = async () => {
      const response = await api.fetch(
        routes.api.landlordPortfolio({ landlordSlug, regionSlug: selectedRegionSlug }),
      );
      const portfolio: LandlordPortfolio = await response.json();
      setSelectedPortfolio(portfolio);
    };
    if (!selectedRegionSlug) return;

    fetchPortfolio();
  }, [selectedRegionSlug, landlordSlug]);

  return {
    selectedPortfolio,
    selectedRegionSlug,
    setSelectedRegionSlug,
  };
}
